/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Chart_Series_SpeedInputs */

const en_ui_chart_series_speed = /** @type {(inputs: Ui_Chart_Series_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Speed (km/h)`)
};

const de_ui_chart_series_speed = /** @type {(inputs: Ui_Chart_Series_SpeedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Geschwindigkeit (km/h)`)
};

/**
* | output |
* | --- |
* | "Speed (km/h)" |
*
* @param {Ui_Chart_Series_SpeedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_chart_series_speed = /** @type {((inputs?: Ui_Chart_Series_SpeedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Chart_Series_SpeedInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_chart_series_speed(inputs)
	return de_ui_chart_series_speed(inputs)
});